import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Point } from 'geojson';
import { MapElement } from '~app/shared/map/map-element.model';
import { FluentFeatureBaseProperties, FluentRestGetFeatureResult } from './fluent-interfaces';
import { default as getTenantConfig } from '~app/shared/map/layer/layer-definitions/T13' ;

const JOENSUU_TENANT_CONFIG = getTenantConfig();

@Component({
  selector: 'qm-fluent-hover',
  templateUrl: './fluent-hover.component.html',
  styleUrls: ['./fluent-hover.component.scss']
})
export class FluentHoverComponent implements OnInit {
  @Input()
  public selectedFeature: MapElement<Point, FluentFeatureBaseProperties>;
  public additionalInfo: {
    request?: {
      carid: string
    },
    result?: {
      status: 'OK' | 'CAR_NOT_FOUND' | 'ERROR';
      carname?: string,
      drivername?: string,
    }
  } = {};
  private readonly JOENSUU_API = {
    baseUrl: JOENSUU_TENANT_CONFIG.tenantCustomData.urls.api,
  };

  constructor(private cdr: ChangeDetectorRef, private http: HttpClient) { }

  ngOnInit() {
  }

  public async requestAdditionalInfo(carid: string) {
    const getSingleResultQueryByCarId = (carid: string) => {
      return `fluent?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&TYPENAMES=latestposwfs&outputformat=geojson&Filter=<Filter><PropertyIsEqualTo><PropertyName>carid</PropertyName><Literal>${carid}</Literal></PropertyIsEqualTo></Filter>`;
    }

    this.additionalInfo = {
      request: {
        carid
      }
    };
    this.cdr.detectChanges();

    try {
      const restResult = await this.http.get<FluentRestGetFeatureResult>(this.JOENSUU_API.baseUrl + getSingleResultQueryByCarId(carid)).toPromise();
      if(restResult.numberMatched === 0) {
        this.additionalInfo = {
          ...this.additionalInfo,
          result: {
            status: 'CAR_NOT_FOUND'
          }
        };
        return;
      }
      // data found
      const firstFeature = restResult.features[0];
      const { carname, drivername} = firstFeature.properties;
      this.additionalInfo = {
        ...this.additionalInfo,
        result: {
          status: 'OK',
          carname,
          drivername
        }
      };
    } catch(e) {
      this.additionalInfo = {
        ...this.additionalInfo,
        result: {
          status: 'ERROR'
        }
      };
    }
  }
}
